import React from 'react';
import { backendApi } from '../api/backendApi';
import { useQuery } from '@tanstack/react-query';
import { FileStack } from 'lucide-react';
import { Card, CardContent } from '../Components/ui/card';
import { Badge } from '../Components/ui/badge';

export default function Submissions() {
  const { data: submissions = [] } = useQuery({
    queryKey: ['submissions'],
    queryFn: () => backendApi.entities.Submission.list('-created_date', 100),
    initialData: []
  });

  const statusColors = {
    'Submitted': 'bg-blue-100 text-blue-800',
    'Under Review': 'bg-yellow-100 text-yellow-800',
    'Shortlisted': 'bg-green-100 text-green-800',
    'Rejected': 'bg-red-100 text-red-800',
    'Interview Scheduled': 'bg-purple-100 text-purple-800'
  };

  return (
    <div className="max-w-[1600px] mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <div className="flex items-center space-x-3">
          <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-3 rounded-lg">
            <FileStack className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Submissions</h1>
            <p className="text-sm text-gray-500">Track candidate submissions</p>
          </div>
        </div>
      </div>
      
      <div className="grid gap-4">
        {submissions.length > 0 ? (
          submissions.map(submission => (
            <Card key={submission.id} className="shadow-sm">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold">{submission.applicant_name}</h3>
                    <p className="text-sm text-gray-600">{submission.job_title}</p>
                  </div>
                  <div className="text-right">
                    <Badge className={statusColors[submission.status]}>{submission.status}</Badge>
                    <p className="text-xs text-gray-500 mt-1">{submission.submission_type}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))
        ) : (
          <Card className="shadow-sm">
            <CardContent className="text-center py-12">
              <FileStack className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">No submissions found</p>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}